module.exports = __webpack_public_path__ + "static/edge_how_2_use-9a80f827783366904cb0efc78ce83325.png";